import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import LandingPage from './pages/LandingPage';
import ReservationPage from './pages/ReservationPage';
import ReservationCancelPage from './pages/ReservationCancelPage';
import TokenCancelPage from './pages/TokenCancelPage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import ReservationManagementPage from './pages/ReservationManagementPage';
import CustomerListPage from './pages/CustomerListPage';
import CareReportPage from './pages/CareReportPage';
import DashboardPage from './pages/DashboardPage';
import CustomerDetailPage from './pages/CustomerDetailPage';
import NotificationPage from './pages/NotificationPage';
import PackageManagementPage from './pages/PackageManagementPage';
import PackageHistoryPage from './pages/PackageHistoryPage';
import TreatmentManagementPage from './pages/TreatmentManagementPage';
import AdminLayout from './layouts/AdminLayout';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

function App() {
  // Axios 설정 (컴포넌트 마운트 시 한 번만 실행)
  useEffect(() => {
    // API 기본 URL 설정 (환경변수 우선, 없으면 현재 도메인 사용)
    const API_URL = process.env.REACT_APP_API_URL || window.location.origin;
    axios.defaults.baseURL = API_URL;

    // 개발 환경에서 URL 확인용 로그
    if (process.env.NODE_ENV === 'development') {
      console.log('API Base URL:', API_URL);
    }

    // 요청 인터셉터: 모든 요청에 토큰 자동 추가
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // 응답 인터셉터: 401 에러 시 자동 로그아웃
    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response && error.response.status === 401) {
          // 인증 실패 시 로컬스토리지 클리어 및 로그인 페이지로 이동
          console.log('🔒 인증 만료: 로그아웃 처리');
          localStorage.removeItem('token');
          localStorage.removeItem('username');
          localStorage.removeItem('role');
          localStorage.removeItem('isLoggedIn');
          
          // 로그인 페이지로 리다이렉트
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );

    // 컴포넌트 언마운트 시 인터셉터 제거
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/reservation" element={<ReservationPage />} />
          <Route path="/reservation-cancel" element={<ReservationCancelPage />} />
          <Route path="/cancel" element={<TokenCancelPage />} />
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected Admin Routes - 중첩 라우팅 구조 */}
          <Route 
            path="/admin" 
            element={
              <PrivateRoute>
                <AdminLayout />
              </PrivateRoute>
            }
          >
            {/* AdminLayout 내부에 렌더링될 자식 라우트들 */}
            <Route index element={<AdminPage />} />
            <Route path="reservations" element={<ReservationManagementPage />} />
            <Route path="customers" element={<CustomerListPage />} />
            <Route path="customers/:id" element={<CustomerDetailPage />} />
            <Route path="care-reports" element={<CareReportPage />} />
            <Route path="packages" element={<PackageManagementPage />} />
            <Route path="packages/history" element={<PackageHistoryPage />} />
            <Route path="treatments" element={<TreatmentManagementPage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="notifications" element={<NotificationPage />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
